// extracted by mini-css-extract-plugin
module.exports = {"sideMenu":"SideMenu_sideMenu__mgnzN","sideMenuOpen":"SideMenu_sideMenuOpen__jhplr","sideMenuButton":"SideMenu_sideMenuButton__mHfkV"};